// Chat lists nest the open chat as …/conversations/:id, except the main list
// (/dashboard) and the mentions/unattended/participating lists, whose own
// path already ends in /conversations. These map "this list" <-> "a chat in it"
// so jumping between a chat and the list-level Kanban keeps the staff's filter.
const LISTS_ENDING_IN_CONVERSATIONS =
  /\/(mentions|unattended|participating)\/conversations$/;

export const listPathOf = path => {
  const withoutId = path.replace(/\/conversations\/\d+\/?$/, '/conversations');
  if (LISTS_ENDING_IN_CONVERSATIONS.test(withoutId)) return withoutId;
  const list = withoutId.replace(/\/conversations$/, '');
  return /\/accounts\/\d+$/.test(list) ? `${list}/dashboard` : list;
};

export const chatPathInList = (listPath, conversationId) => {
  if (listPath.endsWith('/dashboard')) {
    return listPath.replace(/\/dashboard$/, `/conversations/${conversationId}`);
  }
  if (LISTS_ENDING_IN_CONVERSATIONS.test(listPath)) {
    return `${listPath}/${conversationId}`;
  }
  return `${listPath}/conversations/${conversationId}`;
};
